import { render, staticRenderFns } from "./userprofile.vue?vue&type=template&id=36d7147c&scoped=true&"
import script from "./userprofile.vue?vue&type=script&lang=js&"
export * from "./userprofile.vue?vue&type=script&lang=js&"
import style0 from "./userprofile.vue?vue&type=style&index=0&id=36d7147c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7147c",
  null
  
)

export default component.exports